import React, { useState, useEffect, Suspense } from "react";

import euroupFlag from "../../../assets/icons/euro-01.svg";
const Chart = React.lazy(() => import("../../../shared/chart"));

const flag = [
  "us",
  "gbb",
  "tr",
  "ca",
  "au",
  "rs",
  "cn",
  "se",
  "ae",
  "ch",
  "gb",
  "us",
  "usd",
  "no",
  "dk",
  "my",
  "th",
  "iq",
];
const CurrencyItems = ({ items, showSidbarMarginLeft }) => {
  const [archiveCurrencyState, setArchiveCurrencyState] = useState();

  useEffect(() => {}, [showSidbarMarginLeft]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/api/getArchiveForCurrencyChart`, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify({
        id: items.id,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setArchiveCurrencyState(data.data);
      })
      .catch((err) => console.log(err));
  }, [items.id]);

  return (
    <div
      style={{ direction: "rtl" }}
      className={`border bg-white font-semibold text-gray-600 rounded-3xl  shadow-3xlSlate   w-[90%] p-4 px-6
      screen500:px-2
     ${(items.id === 1 || items.id === 2) && " screen500:w-[65%] "}
      `}
    >
      <div className=" flex flex-row justify-between">
        <div className="flex flex-row  w-2/3">
          <div>
            <div className=" mx-auto my-auto ">
              <div
                className={`round-flag-icon round-flag-${
                  flag[items.id - 1]
                } w-14 h-14  mx-auto my-auto 
                screen800:w-11 screen800:h-11 screen600:w-9 screen600:h-9  screen400:w-8 screen400:h-8  screen1800:w-16 screen1800:h-16  
                ${items.id !== 1 && items.id !== 2 && "screen400:w-6"}
                ${items.id !== 1 && items.id !== 2 && "screen1200:w-9 "}
                ${items.id !== 1 && items.id !== 2 && "screen900:w-14 "}
                

        `}
              >
                {(items.id === 2 || items.id === 13) && (
                  <img
                    alt="پرچم اروپا"
                    src={euroupFlag}
                    className="w-14 h-14 screen800:w-11 screen800:h-11 screen600:w-9 screen600:h-9 screen400:w-8 screen400:h-8 screen1800:w-16 screen1800:h-16 "
                  />
                )}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 mr-2 screen1200:mr-1">
            <span
              className={` w-[192%] 
              ${
                showSidbarMarginLeft
                  ? "text-[9px]"
                  : "text-sm   screen600:text-[13px]"
              }
            ${items.id !== 1 && items.id !== 2 && "screen400:text-[11px]"}
            `}
            >
              {items.Currency.name}
            </span>
            <span
              className={` text-gray-400 font-normal  h-fit leading-tight 
              ${
                showSidbarMarginLeft
                  ? "text-[7px] -mt-3"
                  : "text-xs screen600:text-[10px] -mt-4  screen600:-mt-2"
              }
              ${
                items.id !== 1 &&
                items.id !== 2 &&
                "screen500:text-[8px] screen500:-mt-3"
              }
           
            `}
            >
              {items.Currency.symbol}
            </span>
          </div>
        </div>

        <div className=" h-fit my-auto ">
          <Suspense
          // fallback={
          //   <div className="animate-pulse mx-auto w-full">
          //     در حال بارگذاری...
          //   </div>
          // }
          >
            <Chart data={archiveCurrencyState} />
          </Suspense>
        </div>
      </div>

      <div className="screen700:px-3 screen500:px-1">
        <div className="flex flex-row justify-between ">
          <span
            className={` my-auto ${
              showSidbarMarginLeft ? "text-[9px]" : "screen500:text-[11px]"
            }`}
          >
            خرید
          </span>
          <span
            className={` ${
              showSidbarMarginLeft ? "text-[9px]" : "screen500:text-[14px]"
            }`}
          >
            {items.buyPrice.toLocaleString()}
          </span>
        </div>
        <div className="flex flex-row justify-between">
          <span
            className={` my-auto ${
              showSidbarMarginLeft ? "text-[9px]" : "screen500:text-[11px]"
            }`}
          >
            فروش
          </span>
          <span
            className={`${
              showSidbarMarginLeft ? "text-[9px]" : "screen500:text-[14px]"
            }`}
          >
            {items.sellPrice.toLocaleString()}
          </span>
        </div>
      </div>
    </div>
  );
};

export default CurrencyItems;
